"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LuceneQueryUtils = void 0;
const lucene_1 = __importDefault(require("lucene"));
const fox_node_logger_1 = require("@vamstar/fox-node-logger");
const lodash_groupby_1 = __importDefault(require("lodash.groupby"));
const INVALID_TERM = '<implicit>';
class LuceneQueryUtils {
    static parseQuery(query) {
        if (!query || typeof query !== 'string') {
            throw new Error('Invalid query');
        }
        return lucene_1.default.parse(query);
    }
    static isLuceneQuery(query) {
        try {
            const parsedQuery = this.parseQuery(query);
            fox_node_logger_1.log.debug(`Query AST parsedQuery`, parsedQuery);
            return this.isALeftOnlyAST(parsedQuery) || this.isALuceneAST(parsedQuery);
        }
        catch (err) {
            fox_node_logger_1.log.error(`Error while parsing the Lucene query`, err);
            return false;
        }
    }
    static isTermOnly(node) {
        const { field, term } = node;
        return field === INVALID_TERM && term.length !== 0;
    }
    static isQueryLuceneWithOperator(query) {
        try {
            const parsedQuery = this.parseQuery(query);
            fox_node_logger_1.log.debug(`Query AST parsedQuery`, parsedQuery);
            if ('right' in parsedQuery) {
                fox_node_logger_1.log.debug(`Found a binary tree query`);
                const { right, left, operator } = parsedQuery;
                if (operator === INVALID_TERM) {
                    return false;
                }
                return this.isTermOnly(right) && this.isTermOnly(left);
            }
        }
        catch (error) {
            fox_node_logger_1.log.error(`Error while parsing the Lucene query ... ${error}`);
        }
        return false;
    }
    instanceofBinaryAST(object) {
        return 'operator' in object;
    }
    static instanceofLeftOnly(object) {
        const { length, 0: firstKey } = Object.keys(object);
        return length === 1 && firstKey === 'left';
    }
    static isALuceneAST(object) {
        const groupedObjects = (0, lodash_groupby_1.default)([object], 'operator');
        return !Object.keys(groupedObjects).some(key => key === INVALID_TERM);
    }
    static isALeftOnlyAST(object) {
        let result = false;
        if (this.instanceofLeftOnly(object)) {
            result = object.left.term !== INVALID_TERM;
        }
        fox_node_logger_1.log.debug(`Is a NODE ${result}`);
        return result;
    }
}
exports.LuceneQueryUtils = LuceneQueryUtils;
//# sourceMappingURL=data:application/json;base64,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